import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b9f2101&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0b9f2101&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f2101",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/broadband?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230921151340%2Fpages%2Fcompare-tv-broadband-phone%2F_provider%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteAboutProvider: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/site/about-provider.vue').default,SiteAwardsWinner: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/site/awards-winner.vue').default,WidgetsResultsNote: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/widgets/results/note.vue').default,ProductsBroadbandResult: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/products/broadband/result.vue').default,ProductsProviderArticles: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/products/provider-articles.vue').default,ProductsBroadbandCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/products/broadband/capture-point.vue').default,SiteProvidersPlain: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/site/providers-plain.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/site/feefo.vue').default})
